module.exports = __webpack_public_path__ + "img/1538223855.47090d07.jpg";